import React from 'react';
import { AnimatedSection } from '../../../lib/animations/AnimatedSection';

export default function TimelineVertical({ section, data, theme }) {
  const anim = section.animation || {};
  const items = data.events || data.items || [];
  if (items.length === 0) return null;
  const cs = data.customStyle || {};

  return (
    <section
      className="px-5 py-20"
      style={{ backgroundColor: cs.bgColor || undefined }}
      data-testid="timeline-section"
    >
      <div className="max-w-sm mx-auto">
        <AnimatedSection preset={anim.items || 'fade-up'}>
          <p
            className="text-xs tracking-[0.3em] uppercase mb-8 text-center"
            style={{
              color: cs.accentColor || theme.accent,
              fontFamily: cs.fontFamily || theme.eyebrowFont,
              fontSize: cs.fontSize || undefined,
            }}
          >
            {data.title || 'Schedule'}
          </p>
        </AnimatedSection>
        <div className="space-y-6">
          {items.map((item, i) => (
            <AnimatedSection key={i} preset={anim.items || 'stagger-cards'} delay={i * 0.1}>
              <div className="flex gap-4">
                <div className="flex flex-col items-center">
                  <div className="w-2 h-2 rounded-full" style={{ backgroundColor: cs.accentColor || theme.accent }} />
                  {i < items.length - 1 && (
                    <div className="w-px flex-1 mt-1" style={{ backgroundColor: `${cs.accentColor || theme.accent}30` }} />
                  )}
                </div>
                <div className="pb-4">
                  {item.time && (
                    <p className="text-xs" style={{ color: cs.accentColor || theme.accent, fontFamily: cs.fontFamily || theme.eyebrowFont }}>{item.time}</p>
                  )}
                  <p className="text-sm font-medium" style={{ color: cs.textColor || theme.textPrimary, fontFamily: cs.fontFamily || undefined }}>{item.title}</p>
                  {item.description && (
                    <p className="text-xs mt-0.5" style={{ color: cs.textColor ? `${cs.textColor}cc` : theme.textSecondary }}>{item.description}</p>
                  )}
                </div>
              </div>
            </AnimatedSection>
          ))}
        </div>
      </div>
    </section>
  );
}
